const createFakeLink = (link) => {
  document.querySelectorAll(link).forEach((el) => {
    el.addEventListener("click", (event) => {
      window.location.href = event.target.dataset.href;
    });
  });
};

export default createFakeLink;
